import React, { useContext } from 'react';

import { Button, Select, InputNumber, Space, Divider } from 'antd';
import styled from 'styled-components';
import { ApplicationUIContext, Drawer, DrawerContent, Form } from '@yuhuinc/ui-library';

import {
  ValidOperators,
  ValidOperands,
  ValueRequired,
  YuhuModules,
  ValueMin,
  ValueMax,
  ValueAddonAfter,
} from './constants';

const yuhuModuleOptions = Object.keys(YuhuModules).map((m) => ({
  value: m,
  label: YuhuModules[m],
}));

const StyledRow = styled.div`
  display: flex;
  flex-direction: ${({ isMobile }) => (isMobile ? 'column' : 'row')};
  gap: 16px;

  > * {
    flex: 1;
  }
`;

export const StyledSpace = styled(Space)`
  width: 100%;
  .ant-space-item {
    flex: 1;
  }
`;

const requiredField = {
  required: true,
  message: 'Required field',
};

const RuleDrawer = ({ mode, drawer, addRule, initialValues = {} }) => {
  const { isMobile } = useContext(ApplicationUIContext);
  const [form] = Form.useForm();

  const selectedOperand = Form.useWatch('operand', form);
  const selectedYuhuModule = Form.useWatch('yuhu_module', form);

  const operandOptions = () => {
    return ValidOperands[selectedYuhuModule] || [];
  };

  const operatorOptions = () => {
    return ValidOperators[selectedOperand] || [];
  };

  const handleDrawerClose = () => {
    form.resetFields();
    drawer.close();
  };

  const drawerTitle = mode === 'create' ? 'Add Rule' : 'Edit Rule';

  return (
    <Drawer visible={drawer.isVisible} title={drawerTitle} onClose={handleDrawerClose}>
      <DrawerContent>
        <Form
          layout="vertical"
          size={isMobile && 'large'}
          name={`${mode}-rule`}
          form={form}
          initialValues={initialValues}
          scrollToFirstError
          onFinish={(values) => {
            addRule(values);
            handleDrawerClose();
          }}
        >
          <StyledSpace direction="vertical" size="middle">
            <StyledRow isMobile={isMobile}>
              <Form.Item name="id" hidden />

              <Space>
                <Form.Item name="yuhu_module" label="Yuhu Module" rules={[requiredField]}>
                  <Select
                    options={yuhuModuleOptions}
                    onChange={() =>
                      form.setFieldsValue({ operand: null, operator: null, value: null })
                    }
                  />
                </Form.Item>
              </Space>
            </StyledRow>
            <StyledRow isMobile={isMobile}>
              <Space>
                <Form.Item name="operand" label="Trigger" rules={[requiredField]}>
                  <Select
                    options={operandOptions()}
                    disabled={!selectedYuhuModule}
                    onChange={() => form.setFieldsValue({ operator: null, value: null })}
                  />
                </Form.Item>
              </Space>

              <Space>
                <Form.Item name="operator" label="Operator" rules={[requiredField]}>
                  <Select disabled={!selectedOperand} options={operatorOptions()} />
                </Form.Item>
              </Space>

              {selectedOperand && ValueRequired[selectedOperand] && (
                <Space>
                  <Form.Item name="value" label="Value" rules={[requiredField]}>
                    <InputNumber
                      min={ValueMin[selectedOperand]}
                      max={ValueMax[selectedOperand]}
                      addonAfter={ValueAddonAfter[selectedOperand]}
                    />
                  </Form.Item>
                </Space>
              )}
            </StyledRow>
          </StyledSpace>

          <Divider />

          <Space direction="horizontal">
            <Button key="back" onClick={handleDrawerClose}>
              Cancel
            </Button>
            ,
            <Button key="submit" type="primary" htmlType="submit">
              Save changes
            </Button>
          </Space>
        </Form>
      </DrawerContent>
    </Drawer>
  );
};

export default RuleDrawer;
